import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae151f5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract mr-2" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-shield mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    "is-table": "",
    strategy: "fixed"
  }, {
    default: _withCtx(() => [
      (_ctx.havePermission('company.update-mass-approve'))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "primary small",
            loading: _ctx.mass_state.is_loading,
            onClick: _ctx.manageMassApprove
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.massApproveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanResendContract)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "primary small text",
            loading: _ctx.state.is_dogovor_loading,
            onClick: _ctx.resendContract
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Переотправить договор ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanResendTo1C)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 2,
            class: "primary small text",
            loading: _ctx.state.is_1c_loading,
            onClick: _ctx.resendTo1C
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Переотправить в 1С ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.havePermissions(['company-set-client-email', 'all-root-permission']))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 3,
            class: "primary small",
            onClick: _ctx.emitSet
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Почта клиентов ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.emitApply
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Присвоить бухгалтера ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.emitGenerate
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" Сгенерировать договор ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.emitPayers
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Плательщики ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: _normalizeClass(["primary small", { 'red text': _ctx.item.verify }]),
        loading: _ctx.state.is_loading,
        onClick: _ctx.handleVerification
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(`${_ctx.item.verify ? 'Отключить' : 'Включить'} верификацию`), 1)
        ]),
        _: 1
      }, 8, ["loading", "class", "onClick"]),
      ([1, 3].includes(_ctx.item.status_id))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 4,
            class: "green text small",
            loading: _ctx.activation_state.is_loading,
            onClick: _ctx.activateCompany
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Активировать ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : (_openBlock(), _createBlock(_component_the_button, {
            key: 5,
            class: "text small red",
            loading: _ctx.activation_state.is_loading,
            onClick: _ctx.deactivateCompany
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Деактивировать ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.emitReset
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Сбросить пароль ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.item.billing_enabled && Boolean(_ctx.item.billing_period))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 6,
            class: "primary small",
            onClick: _ctx.emitGenerateTranscript
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Сформировать транскрипт ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.toggleBilling
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Свойства Биллинга ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.canToggleSmsSetting)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 7,
            loading: _ctx.state.is_sms_toggle_loading,
            class: "primary text small",
            onClick: _ctx.toggleSmsSetting
          }, {
            default: _withCtx(() => [
              (_ctx.isSmsSettingActivated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Выключить СМС")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Включить СМС")
                  ], 64))
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}